var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, DatePicker, FieldValidation, } from '#design-system';
import { useField, useFieldDependency } from '#form-builder';
import { C } from '#integrations';
import styles from './DatePickerField.module.css';
const defaultValidationRules = [];
export const DatePickerField = ({ 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus, calendarPlacement, className, clientErrorMessage, 'data-testid': testId, description, disabled, id, initialValue, label, labelTooltip, max, min, placeholder, readOnly, required, rules = defaultValidationRules, staticContainer, tooltipPosition, wordings, ...props }) => {
    _react_refresh_temp_2();
    const placementProps = calendarPlacement === 'static'
        ? { calendarPlacement, staticContainer: staticContainer ?? null }
        : { calendarPlacement: 'popup' };
    const builtInitialValue = useMemo(() => {
        if (typeof initialValue === 'function') {
            return initialValue({}) || new Date();
        }
        else {
            return initialValue || new Date();
        }
    }, [initialValue]);
    const { 
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- dependencyValue is any on purpose
    dependencyValue, errors, fieldRef, isFocused, isTouched, onBlurHandler, onChangeHandler, onFocusHandler, value, } = useField({
        autoFocus,
        ...props,
        disabled,
        initialValue: builtInitialValue,
    });
    const dependantData = useFieldDependency({
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- dependencyValue is any on purpose
        dependencyValue,
        disabled,
        label,
        required,
    });
    const hasErrors = Boolean(errors.length) && isTouched;
    const fieldValidationId = `field-validation-${id}`;
    return (_jsxs(Box, { className: C(styles.Container, className), gap: "xs", isFullWidth: true, orientation: "vertical", children: [_jsx(DatePicker, { "aria-describedby": fieldValidationId, ...(hasErrors && { 'aria-errormessage': fieldValidationId }), ...(hasErrors && { 'aria-invalid': true }), "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, autoFocus: autoFocus, "data-testid": testId, description: description, disabled: dependantData.disabled, hasErrors: hasErrors, id: id, label: dependantData.label, labelTooltip: labelTooltip, max: max, min: min, onBlur: onBlurHandler, onChange: (date) => {
                    onChangeHandler(date);
                }, onFocus: onFocusHandler, placeholder: placeholder, required: dependantData.required, ...placementProps, readOnly: readOnly, ref: fieldRef, tooltipPosition: tooltipPosition, value: value, wordings: wordings }), _jsx(FieldValidation, { clientErrorMessage: clientErrorMessage, "data-testid": testId, errors: errors, id: fieldValidationId, isActive: isTouched, isFocused: isFocused, rules: rules })] }));
};
_react_refresh_temp_1 = DatePickerField;
$RefreshReg$(_react_refresh_temp_1, "DatePickerField");
_react_refresh_temp_2(DatePickerField, "7LnEM1IR9rsqY4ujvpRYmMDdRBE=", false, () => [useField, useFieldDependency]);
